import React, { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { useI18n } from '../../contexts/I18nContext';
import { applyPwaUpdate, subscribePwaNeedRefresh } from '../../pwa/registerSW';

const PwaUpdatePrompt: React.FC = () => {
  const { t } = useI18n();
  const [needsRefresh, setNeedsRefresh] = useState(false);

  useEffect(() => {
    return subscribePwaNeedRefresh(() => setNeedsRefresh(true));
  }, []);

  if (!needsRefresh) return null;

  return (
    <div
      role="alertdialog"
      aria-labelledby="pwa-update-title"
      style={{
        position: 'fixed',
        top: 'max(12px, env(safe-area-inset-top))',
        left: '50%',
        transform: 'translateX(-50%)',
        width: 'min(420px, calc(100vw - 24px))',
        zIndex: 10060,
        backgroundColor: '#1f2937',
        color: '#fff',
        borderRadius: '10px',
        boxShadow: '0 6px 20px rgba(0,0,0,0.2)',
        padding: '12px 14px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
      }}
    >
      <RefreshCw size={18} aria-hidden />
      <span id="pwa-update-title" style={{ flex: 1, fontSize: '14px', fontWeight: 500 }}>
        {t('pwa.update.title')}
      </span>
      <button
        type="button"
        onClick={() => applyPwaUpdate()}
        aria-label={t('pwa.update.action')}
        style={{
          padding: '6px 12px',
          borderRadius: '8px',
          border: 'none',
          background: '#6b21a8',
          color: '#fff',
          cursor: 'pointer',
          fontWeight: 600,
          fontSize: '13px',
          whiteSpace: 'nowrap',
        }}
      >
        {t('pwa.update.action')}
      </button>
    </div>
  );
};

export default PwaUpdatePrompt;
